import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MuiToolbar from '@mui/material/Toolbar';
import { tabsClasses } from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SideMenuMobile from './SideMenuMobile';
import MenuButton from './MenuButton';
import MuscleHeadTextIcon from '../../../assets/MuscleHeadTextIcon';

import { Link } from 'react-router-dom';

const Toolbar = styled(MuiToolbar)({
  width: '100%',
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'center',
  gap: '12px',
  flexShrink: 0,
  [`& ${tabsClasses.flexContainer}`]: {
    gap: '8px',
    p: '8px',
    pb: 0,
  },
});

export default function AppNavbar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"  
      sx={{
        display: { xs: 'auto', md: 'none'},
        boxShadow: 0,
        bgcolor: 'background.paper',
        backgroundImage: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
        top: 'var(--template-frame-height, 0px)',
      }}
    >
      <Toolbar variant="regular" sx={{p:1}}>
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            flexGrow: 1,
            width: '100%',
          }}
        >
          {/* <Stack direction="row" spacing={1} sx={{
            justifyContent: 'center',
            alignItems: 'center',
            }}> */}
            <Link to="/admin/dashboard">
              <CustomIcon />
            </Link>
            <Typography variant="h5" component="h3" sx={{
              color: 'text.primary',
              pl: 2,
              }}>
              {/* <NavbarBreadcrumbs />  */}
            </Typography>
          {/* </Stack> */}
          
          <MenuButton aria-label="menu" onClick={() => toggleDrawer(true)}>
            <MenuRoundedIcon />
          </MenuButton>
          <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export function CustomIcon() {
  return (
    <Box
      sx={{
        height: '100%',
        width: 'auto',
        // bgcolor: theme.palette.grey[100],
        // borderRadius: '999px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        
      }}
    >
      <MuscleHeadTextIcon sx={{ fontSize: '3rem' }} />
    </Box>
  );
}
